import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import RedeImg from "../../assets/images/rede-vantagens-img.webp";
import AutoPlayCarousel from "../AutoPlayCarousel";
import { RiDiscountPercentLine } from "react-icons/ri";
import { TbCoinOff } from "react-icons/tb";
import { RiStore2Line } from "react-icons/ri";
import { LuHeartPulse } from "react-icons/lu";
import { PiHandDepositBold } from "react-icons/pi";
import "./RedeVantagens.css";

export default function RedeVantagens(props) {
  return (
    <div>
      <Container>
        <Row>
          <Col className="rede-vantagens-first-col">
            <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
              <PiHandDepositBold
                style={{ color: props.iconColor }}
                className="rede-vantagens-first-col-icon "
              />
              REDE DE VANTAGENS KRAUSE
            </h2>
          </Col>
        </Row>
        <Row>
          <Col className="rede-vantagens-second-col">
            <p style={{ color: props.textColor, fontSize: props.textSize }}>
              Sua família com vantagens incríveis sem pagar a mais por isso! Ao
              contratar o Plano Assistencial Grupo Krause, você passa
              automaticamente a fazer parte da Rede de Vantagens Krause, com
              serviços exclusivos para aproveitar e proteger sua família todos
              os dias!
            </p>
          </Col>
        </Row>
        <Row>
          <Col lg={6} className="rede-vantagens-fourth-col">
            <div>
              <div className="rede-vantagens-item">
                <RiDiscountPercentLine
                  style={{ color: props.iconColor }}
                  className="rede-vantagens-icon"
                />
                <h4
                  style={{
                    color: props.subTitleColor,
                    fontSize: props.textSize,
                  }}
                >
                  Descontos e facilidades exclusivas para toda a família
                </h4>
              </div>
              <div className="rede-vantagens-item">
                <TbCoinOff
                  style={{ color: props.iconColor }}
                  className="rede-vantagens-icon"
                />
                <h4
                  style={{
                    color: props.subTitleColor,
                    fontSize: props.textSize,
                  }}
                >
                  Sem custo adicional para associados e dependentes
                </h4>
              </div>
              <div className="rede-vantagens-item">
                <RiStore2Line
                  style={{ color: props.iconColor }}
                  className="rede-vantagens-icon"
                />
                <h4
                  style={{
                    color: props.subTitleColor,
                    fontSize: props.textSize,
                  }}
                >
                  Acesso a mais de 300 estabelecimentos e serviço na área da
                  saúde, comércio, serviços e bem-estar
                </h4>
              </div>
              <div className="rede-vantagens-item">
                <LuHeartPulse
                  style={{ color: props.iconColor }}
                  className="rede-vantagens-icon"
                />
                <h4
                  style={{
                    color: props.subTitleColor,
                    fontSize: props.textSize,
                  }}
                >
                  Convênio com diversas farmácias, hospitais, clínicas,
                  laboratórios, entre outros
                </h4>
              </div>
            </div>
            {/* AGUARDANDO DEFINIÇÃO SE OS PARCEIROS SERÃO MOSTRADOS EM LISTA POR API OU PDF
            <CustomButton
              className="primary-btn"
              variant="primary"
              href="https://centraldocliente.grupokrause.com.br/login?redirect=/boletos"
              icon=""
              content="LISTA DE PARCEIROS"
              backgroundColor={props.btnColor}
              fontFamily="Unageo-Bold"
              fontColor={props.white}
              fontSize={20}
              width={260}
              borderColor={props.btnColor}
              disabled={false}
            />*/}
          </Col>
          <Col
            lg={{ span: 6, order: "first" }}
            className="rede-vantagens-third-col"
          >
            <div className="rede-vantagens-img-container">
              <img src={RedeImg} alt="Descontos rede de vantagens" />
              <div className="rede-vantagens-img-overlay" />
            </div>
          </Col>
        </Row>
      </Container>
      <AutoPlayCarousel />
    </div>
  );
}
